import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getInspectionData = async (id) => {
	const service = await getService(serviceNames.perInspections);
	return service.find({
		query: {
			id,
			isDeleted: false,
		},
	});
};

export const updateInspectionData = async (id, data) => {
	const service = await getService(serviceNames.perInspections);
	const response = await service.patch(id, data);
	return response;
};

export const getInspectionTypeOptions = async (dictionary) => {
	const codePerInspectionTypes = dictionary?.codePerInspectionTypes || [];

	if (codePerInspectionTypes.length > 0) {
		return codePerInspectionTypes.map((type) => ({
			label: type?.Code || type?.code,
			value: type?.Code || type?.code,
			ptsCodeId: type?.ptsCodeId,
		}));
	}

	return [];
};

export const getChecklistItems = async (userAgency) => {
	const service = await getService(serviceNames.perChecklistItems);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
			isActive: true,
			$limit: -1,
		},
	});

	return response?.data || response || [];
};
